const UploadFile = {
  mounted(){
    this.el.addEventListener('click', () => {
      this.el.querySelector('input[type=file]').click()
    })
  }
}

export default { UploadFile };
